import React from 'react';
import { useHistory } from 'src/services/useHistory';

import { CommonNavBarButton } from 'src/components/CommonNavBarButton';
import { useUserActions } from 'src/store';
import { ROUTES } from 'src/routes';
import useStyles from './useStyles';

export const ItemsMobile = () => {
  const styles = useStyles();
  const history = useHistory();

  const userActions = useUserActions();

  const handleLogout = React.useCallback(() => {
    userActions.logout();
    // Redirect to SignIn page and ask to not go back from it
    history.push(ROUTES.SIGN_IN, { state: { disableFrom: true } });
  }, [userActions, history]);

  return (
    <CommonNavBarButton className={styles.button} onClick={handleLogout}>
      Log out
    </CommonNavBarButton>
  );
};
